module.exports = __webpack_public_path__ + "assets/59b4bb695ba4bff8ab6637e763b42325.png";